<template>
  <div class="col-md-4 d-none d-md-block">
    <div class="input-group position-relative">
      <AutoComplete
        v-model="busca"
        :suggestions="buscaFiltrada"
        @complete="buscarProdutos($event)"
        @item-select="irProduto($event)"
        field="name"
        placeholder="Pesquise por produtos"
        id="basic_search"
        class="search-input"
      />
      <span class="material-icons abs">search</span>
    </div>
    <div class="input-group d-none">
      <input
        type="text"
        class="form-control"
        placeholder="Pesquise por serviços"
        aria-label="Recipient's username"
        aria-describedby="basic-addon2"
        v-model="busca"
        @keyup="buscarProdutos"
      />
      <div class="input-group-append">
        <span
          class="input-group-text"
          @click.prevent="buscarProdutos"
          id="basic"
        >
          <span class="material-icons">search</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import AutoComplete from "primevue/autocomplete";
import produtosList from "../produtos.json";
import { filterByValue } from "../helpers.js";
export default {
  name: "ProdutosBuscar",
  data() {
    return {
      busca: "",
      buscaFiltrada: [],
      produtos: produtosList.produto,
    };
  },
  components: {
    AutoComplete,
  },
  methods: {
    irProduto(event) {
      this.$router.push({ name: event.value.id });
    },
    buscarProdutos(event) {
      this.buscaFiltrada = filterByValue(this.produtos, event.query);
    },
  },
};
</script>

<style lang="scss">
.search-input {
  display: flex;
  justify-content: center;
  width: 100%;
  input {
    width: 100% !important;
  }
}
.abs {
  position: absolute;
  right: 10px;
  top: 8px;
}
.p-inputtext:enabled:hover {
  border-color: lightblue !important;
}
.p-inputtext:enabled:focus {
  box-shadow: 0 0 0 0.2rem transparent !important;
  border-color: lightblue !important;
}
</style>
